"use strict";
// Copyright (c) 2022 Move Closer
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSRFServiceType = void 0;
exports.CSRFServiceType = Symbol.for('CSRFService');
